import { assertUnreachableOrReturnDefault } from './assertUnreachable';
import { BillingPlanKind, BillingPlanTier } from './graphqlTypes/types';

/**
 * Return mapped name for different plan tiers and kinds
 * @param name plan name stored in DB
 * @param tier BillingPlanTier
 * @param kind BillingPlanKind
 * @returns string
 */
export const planNameMapper = (
  name: string,
  tier: BillingPlanTier,
  kind: BillingPlanKind,
): string => {
  switch (tier) {
    case BillingPlanTier.ENTERPRISE:
      return kind === BillingPlanKind.DEDICATED
        ? name
        : kind === BillingPlanKind.ENTERPRISE_TRIAL
          ? 'Enterprise Trial'
          : 'Enterprise';
    case BillingPlanTier.TEAM:
      return 'Team';
    case BillingPlanTier.COMMUNITY:
      return 'Legacy Free';
    case BillingPlanTier.DEVELOPER:
      return 'Developer';
    case BillingPlanTier.STANDARD:
      return 'Standard';
    case BillingPlanTier.SCALE:
      return 'Developer';
    case BillingPlanTier.FREE:
    case BillingPlanTier.NONE:
    case BillingPlanTier.UNKNOWN:
    case BillingPlanTier.USAGE_BASED:
      return name;
    default:
      return assertUnreachableOrReturnDefault(tier, name);
  }
};
